import { Link, Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import theme from 'artkive/utils/theme'

export const SectionHeading = withStyles(({ spacing }) => ({
  root: {
    color: theme.colors.black,
    letterSpacing: '1px',
    fontSize: '13px',
    fontWeight: '600',
    textTransform: 'uppercase',
    marginBottom: spacing(1),
  },
}))(Typography)

export const SitemapLink = withStyles(({ palette }) => ({
  root: {
    color: palette.text.secondary,
    fontWeight: 600,
  },
}))(Link)

export const LinkList = styled('ul')({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  lineHeight: 2,
})
